module.exports = __webpack_public_path__ + "static/media/SerieBT4.e10eaec2.jpg";